import React from 'react';
import {useTranslation} from 'react-i18next';
import {PaperAirplaneIcon as ProjectShareIcon} from '@heroicons/react/24/outline';
import {useUser} from '@lore/auth';
import PropTypes from 'prop-types';
import Header from './Header';
import Date from './Date';
import Creator from './Creator';
import classNames from 'classnames';
import School from './School';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import {DialogManager} from '@/dialogs_new/DialogManager';
import Partners from '@/pages/projects/Row/Partners';
import useIsProjectShareable from '@/features/share-project/hooks/useIsProjectShareable';
import Notes from '@/pages/projects/Row/Notes';
import StatusTags from '@/pages/projects/Row/StatusTags';
import Bookmark from '@/pages/_components/Bookmark';
import Network from './Network';

export default function Project(props) {
  const { project, className, children, notes = true } = props;

  const { t } = useTranslation();

  const currentUser = useUser();

  const launch = useDialogLauncher();

  const canShare = useIsProjectShareable(project);

  function onClick() {
    if (props.onClick) {
      props.onClick();
    } else {
      launch(DialogManager.ProjectManage.Config(project.id));
    }
  }

  return (
    <div className={classNames(
      'flex flex-col bg-white',
      'shadow-cs-flat rounded-cs-10',
      '-m-0.5 border-2 border-cs-gray-100',
      'relative overflow-hidden',
      // 'hover:bg-cs-orange-50 cursor-pointer',
      className
    )}>
      {/*<Link to={`/projects/${project.id}`} className="absolute w-full h-full" />*/}
      <div className="absolute z-10 top-4 right-4 pt-0.5x pr-0.5x flex items-center gap-3">
        {canShare && (
          <button
            type="button"
            aria-label={t('project_share.cta')}
            className="flex items-center gap-1 text-cs-orange-500 hover:opacity-75"
            onClick={(e) => {
              e.stopPropagation();
              launch(DialogManager.ProjectShare.Config(project.id));
            }}
          >
            <ProjectShareIcon className="h-5 w-5 -rotate-[30deg]" aria-hidden="true" />
            <span className="hidden sm:inline text-sm font-semibold">{t('project_share.cta')}</span>
          </button>
        )}
        <Bookmark
          type="project"
          resource={project}
        />
      </div>
      <div className="flex flex-col py-4 px-4 space-y-2 hover:bg-cs-orange-50 cursor-pointer" onClick={onClick}>
        {/*<div className="flex space-x-2 min-h-5">*/}
        {/*  /!*<Activity activity={activity} />*!/*/}
        {/*  <StatusTags project={project} />*/}
        {/*</div>*/}
        <StatusTags project={project} />
        <div className={classNames('pr-10', canShare && 'pr-20 sm:pr-44')}>
          <Header project={project} />
        </div>
        <div className="flex flex-col sm:flex-row items-start justify-between">
          <div className="flex flex-1 flex-wrap gap-x-4 gap-y-2 mb-2 sm:mb-0">
            <Date project={project}/>
            {/*<Time project={project} />*/}
            <Creator project={project}/>
            <School project={project}/>
            {currentUser.data.isStaff && (
              <Network project={project}/>
            )}
          </div>
          {/*<Distance project={project} />*/}
          <Partners project={project}/>
        </div>
      </div>
      {/*{false && (*/}
      {/*  <div className={classNames(*/}
      {/*    'w-full py-4 px-4',*/}
      {/*    'bg-cs-gray-50',*/}
      {/*    '-mt-px border-t border-cs-gray-100',*/}
      {/*  )}>*/}
      {/*    <Participation project={project} />*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*<Participation project={project} />*/}
      {children}
      {notes && (
        <div className="bg-gray-50 p-4">
          <Notes project={project}/>
        </div>
      )}
    </div>
  );
}


Project.propTypes = {
  project: PropTypes.shape({
    data: PropTypes.shape({
      activityId: PropTypes.number.isRequired,
      completed: PropTypes.bool,
      cancelled: PropTypes.bool,
      published: PropTypes.bool,
      specificDate: PropTypes.string,
      date: PropTypes.string,
      endDate: PropTypes.string
    }).isRequired,
    id: PropTypes.number.isRequired
  }).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  notes: PropTypes.bool,
  onClick: PropTypes.func
};

Project.defaultProps = {
  notes: true
};
